import React, { useState } from 'react';
import {
	Modal,
	MimaText,
	MimaInput,
	MimaButton,
	MimaTextArea,
	MimaDropdown,
	ReceiptCheckBox as RCB,
} from '../../components';

import styles from '../../assets/styles/Settings/Settings.module.scss';
import { Formik } from 'formik';

const InventoryConfig = ({
	reminderTime,
	closeModal,
	goBack,
	loading,
	onSubmit,
	productConfig,
}) => {
	const [config, setConfig] = useState(!!productConfig?._id)
	
	return (
		<Modal closeModal={closeModal}>
			{!config && (
				<div className={styles.iconfig}>
					<MimaText variant="bodyBold">
						Update Stock Configuration
					</MimaText>
					<Formik
						initialValues={{
							depositPer: productConfig.depositPer || 0,
							vat: !!(productConfig?.vat),
							splitPaymentTrigger: productConfig.splitPaymentTrigger || '',
							lowStockReminderTimer: productConfig.lowStockReminderTimer || 0,
							termsAndConditions: productConfig.termsAndConditions || '',
							reminderTimerName: productConfig.reminderTimerName || "",
						}}
						onSubmit={onSubmit}
					>
						{({
							handleChange,
							handleBlur,
							handleSubmit,
							setFieldValue,
							values,
							errors,
							touched,
						}) => (
							<div>

								<MimaText
									variant="smallBold"
									align="center"
									color="var(--color-primary)"
									mt={2}
									mb={2}
									width={36}
								>Set reminder frequency for Low Stock/Out of stock notification</MimaText>

								<MimaDropdown
									labelTitle="Set reminder"
									placeholder="none"
									name="lowStockReminderTimer"
									id="lowStockReminderTimer"
									data={reminderTime}
									onChange={data => {
										setFieldValue('lowStockReminderTimer', data.key);
									}}
									error={errors.lowStockReminderTimer}
									touched={touched.lowStockReminderTimer}
								/>

								<MimaInput
									type="number"
									labelTitle="Mininmum deposit for sale? (%)"
									name="depositPer"
									mb={2}
									value={values.depositPer}
									onChange={handleChange}
									onBlur={handleBlur}
									touched={touched.depositPer}
								/>

								<MimaText variant="smallBold" align="center" color="var(--color-primary)" mb={2}>
									Do you want to charge VAT?
								</MimaText>
								<div className={styles.bicContainer}>
									<div className={styles.bicContainer__bic}>
										<RCB
											title="Yes"
											id="YES"
											name="vat"
											onChange={() => {
												setFieldValue('vat', true);
											}}
											checked={values.vat}
											value={true}
										/>
										<RCB
											title="No"
											id="NO"
											name="vat"
											onChange={() => {
												setFieldValue('vat', false);
											}}
											checked={!values.vat}
											value={false}
										/>
									</div>
								</div>
								<MimaText
									variant="smallBold"
									align="center"
									style={{ maxWidth: "36rem" }}
									color="var(--color-primary)"
								>
									When after sales do you want to trigger Split payment with the vendor?
								</MimaText>
								<MimaDropdown
									labelTitle=""
									placeholder={values.splitPaymentTrigger || '-Select-'}
									name="splitPaymentTrigger"
									value={values.splitPaymentTrigger}
									currentValue={values.splitPaymentTrigger}
									id="splitPaymentTrigger"
									onChange={data => {
										setFieldValue('splitPaymentTrigger', data.key);
									}}
									data={['IMMEDIATELY', 'END OF DAY', 'NEXT DAY', 'END OF WEEK', 'MONTH END'].map(value => {
										return {
											key: value,
											value,
										}
									})}
									touched={touched.splitPaymentTrigger}
								// width={36}
								/>
								<MimaTextArea
									type="textarea"
									labelTitle="Terms and conditions"
									name="termsAndConditions"
									mb={2}
									mt={2}
									variant="message"
									value={values.termsAndConditions}
									onChange={handleChange}
									onBlur={handleBlur}
								/>
								<MimaButton
									title="Save"
									loading={loading}
									type="submit"
									onClick={handleSubmit}
								/>
							</div>
						)}
					</Formik>
				</div>
			)}

			{config && (
				<div>
					<MimaText variant="subtitleBold" align="center" mb={5}>
						Stock Configuration
					</MimaText>
					<div className={styles.configDetails}>
						<MimaText variant="small" color="var(--color-primary)">Reminder timeline</MimaText>
						<MimaText variant="small">{`Every ${productConfig.lowStockReminderTimer}hrs`}</MimaText>
					</div>
					<div className={styles.configDetails}>
						<MimaText variant="small" color="var(--color-primary)">Mininmum deposit for sale (%)</MimaText>
						<MimaText variant="small">{productConfig.depositPer}</MimaText>
					</div>
					<div className={styles.configDetails}>
						<MimaText variant="small" color="var(--color-primary)">Charge VAT</MimaText>
						<MimaText variant="small" >{productConfig.vat.toString()}</MimaText>
					</div>
					<div className={styles.configDetails}>
						<MimaText variant="small" color="var(--color-primary)">When to trigger split payment with vendor</MimaText>
						<MimaText variant="small">{productConfig.splitPaymentTrigger}</MimaText>
					</div>
					<div className={styles.configDetails}>
						<MimaText variant="small" color="var(--color-primary)">Terms and conditions</MimaText>
						<MimaText variant="small">{productConfig.termsAndConditions}</MimaText>
					</div>
					<div className={styles.configDetails_btn}>
						<MimaButton
							title="Edit"
							onClick={() => {
								setConfig(!config)
							}}
							mt={4}
						/>
					</div>

				</div>
			)}
		</Modal>
	);
};

export default InventoryConfig;